import React, { Component } from 'react';
import { myLog, translate } from '../../helper';
import { Colors } from '../../themes/Colors';
import TextBase from '../text';
import { css, StyleSheet } from 'aphrodite';
import { SVGImageComponentReact } from '../../themes/Images';
import './index.css';
import { sizeBase } from '../../utils/defined';

const styles = StyleSheet.create({
  container: {
    // width: "fit-content",
  },
  selectContainer: {
    borderRadius: sizeBase.borderRadiusInputForm,
    border: 'solid 1px',
    borderColor: Colors.borderSelect,
    background: Colors.white,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: sizeBase.paddingInput.left,
    paddingRight: sizeBase.paddingInput.right,
    cursor: 'pointer',
    transition: 'border-color 150ms ease',
    ':focus': {
      borderColor: '#1976d2'
    }
  },
  selectContainerOpen: {
    borderColor: '#1976d2 !important'
  },
  optionContainer: {
    maxHeight: 'calc(var(--fs-hero)*6.60377)',
    backgroundColor: Colors.white,
    borderRadius: sizeBase.borderRadiusInputForm,
    border: 'solid 1px',
    borderColor: Colors.borderSelect,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    position: 'absolute',
    zIndex: 9999999
  },
  optionItem: {
    width: '100%',
    backgroundColor: Colors.white,
    fontSize: 'calc(var(--fs-xs)*1.4150943)',
    fontWeight: 400,
    color: Colors.black,
    height: sizeBase.inputForm.height,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: sizeBase.paddingInput.left,
    paddingRight: sizeBase.paddingInput.right,
    cursor: 'pointer',
    borderBottom: '1px solid #f0f0f0',
    transition: 'background-color 0.15s ease',
    ':hover': {
      backgroundColor: Colors.bgSubSelect,
      color: Colors.blackTitle
    }
  },
  optionItemSelected: {
    backgroundColor: '#EEF2FF',
    color: Colors.blackTitle,
    fontWeight: 500
  },
  optionSubItem: {
    width: '100%',
    backgroundColor: Colors.white,
    fontSize: 'calc(var(--fs-xs)*1.32075)',
    fontWeight: 400,
    color: Colors.borderCheckbox,
    height: sizeBase.inputForm.height,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'calc(var(--sp-lg)*2.641509)',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: Colors.bgSubSelect,
      color: Colors.blackTitle
    }
  },
  txtOption: {
    color: '',
    width: '100%',
    ':hover': {
      color: Colors.blackTitle
    }
  },
  subSelect: {
    width: '100%',
    backgroundColor: Colors.bgSubSelect,
    height: sizeBase.inputForm.height,
    paddingLeft: sizeBase.paddingInput.left,
    paddingRight: sizeBase.paddingInput.right,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  optionFistBorder: {
    borderTopLeftRadius: sizeBase.borderRadiusInputForm,
    borderTopRightRadius: sizeBase.borderRadiusInputForm
  },
  optionLastBorder: {
    borderBottomLeftRadius: sizeBase.borderRadiusInputForm,
    borderBottomRightRadius: sizeBase.borderRadiusInputForm
    // borderBottom: "solid 1px",
    // borderBottomColor: Colors.borderSelect,
  },
  searchSticky: {
    position: 'sticky',
    top: 0,
    zIndex: 99,
    background: Colors.white,
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  mobileOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 99999999,
    backgroundColor: 'rgba(0,0,0,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'calc(var(--sp-md2))'
  },
  mobileOverlayPanel: {
    maxHeight: '90vh',
    backgroundColor: Colors.white,
    borderRadius: sizeBase.borderRadiusInputForm,
    border: 'solid 1px',
    borderColor: Colors.borderSelect,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  mobileOptionsScroll: {
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
  }
});
export default class SelectCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSelect: false,
      openKeys: [],
      search: '',
      triggerWidth: 0,
      triggerLeft: 0
    };
    this.refContainer = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.openSelect && this.state.openSelect) {
      if (this.refSelect) {
        const rect = this.refSelect.getBoundingClientRect();
        this.setState({
          triggerWidth: rect.width,
          triggerLeft: rect.left,
        });
      }
    }
  }

  setSearch = (terms) => {
    this.setState({ search: terms });
  };
  handleClickOutside = (event) => {
    if (this.refSelect && !this.refSelect.contains(event.target)) {
      if (this.state.openSelect) {
        this.setState({
          openSelect: false,
          search: ''
        });
      }
    }
  };
  getFilteredItems = (items = []) => {
    const { search } = this.state;

    if (!search || !search.trim()) return items;

    const term = search.toLowerCase().trim();
    const termNoPlus = term.replace('+', '');

    const filtered = items.filter((item) => {
      const title = (item.title || "").toLowerCase();
      const short = (item.short || "").toLowerCase();
      const code = (item.key || "").toString();

      return (
        title.includes(term) ||
        short.includes(term) ||
        code.includes(termNoPlus)
      );
    });

    // ranking
    return filtered.sort((a, b) => {
      const aTitle = a.title.toLowerCase();
      const bTitle = b.title.toLowerCase();

      if (aTitle === term) return -1;
      if (bTitle === term) return 1;

      if (aTitle.startsWith(term) && !bTitle.startsWith(term)) return -1;
      if (!aTitle.startsWith(term) && bTitle.startsWith(term)) return 1;

      return aTitle.localeCompare(bTitle);
    });
  };
  getOptions = (items = []) => {
    const { value } = this.props;

    return items.map((item, index) => {
      const isSelected = item.key === value;

      return (
        <div
          key={item.key + "_" + index}
          className={
            css(styles.optionItem) +
            " " +
            (isSelected ? css(styles.optionItemSelected) : "")
          }
          onClick={() => {
            this.setState({ openSelect: false, search: "" });
            this.props.onSelect && this.props.onSelect(item.key);
          }}
        >
          {item.title}
        </div>
      );
    });
  };
  getTitleShow = (items = []) => {
    const { value } = this.props;
    let titleReturn = '';
    items.forEach((item) => {
      if (item.items) {
        titleReturn = this.getTitleShow(item.items);
      } else {
        if (item.key === value) {
          titleReturn = item?.short || item.title || '';
        }
      }
    });
    return titleReturn;
  };
  render() {
    const { openSelect } = this.state;
    const { placeholder, value, items, width, searchPlaceholder, selectContainerheight, positionFromTrigger } = this.props;
    const isMobileOverlay = this.props.isMobileView && this.props.disableMobileOverlay !== true;
    const filteredItems = this.getFilteredItems(items || [])
    const options = this.getOptions(filteredItems);
    const titleShow = this.getTitleShow(items);
    const isSmallDevice = window.innerWidth <= 768;
    myLog('renderSelect=>', titleShow);
    return (
      <div
        className={css(styles.container) + ' position-relative'}
        ref={(ref) => (this.refSelect = ref)}>
        <div
          onClick={() => {
            if (!this.props.disabled) {
              this.setState({
                openSelect: !openSelect
              });
            }
          }}
          className={css(styles.selectContainer) + (openSelect ? ' ' + css(styles.selectContainerOpen) : '')} 
          style={{
            height: positionFromTrigger ? selectContainerheight : sizeBase.inputForm.height, 
            marginTop: positionFromTrigger? '0' : 'calc(var(--sp-xxs)*2)',
            transition: 'border-color 150ms ease'
          }}>
          <TextBase
            color={titleShow ? Colors.black : Colors.borderCheckbox}
            size={'calc(var(--fs-xs)*1.50943)'}>
            {titleShow || placeholder || 'Select item'}
          </TextBase>
          {openSelect ? (
            <SVGImageComponentReact.IconUpArrow style={{ height: 'calc(var(--sp-md2)*1.32075)', width: 'calc(var(--sp-md2)*1.32075)' }} />
          ) : (
            <SVGImageComponentReact.IconDownArrow style={{ height: 'calc(var(--sp-md2)*1.32075)', width: 'calc(var(--sp-md2)*1.32075)' }} />
          )}
        </div>
        {openSelect ? (
          isMobileOverlay ? (
            <div
              className={css(styles.mobileOverlay)}
              onClick={() => {
                if (!this.props.disabled) {

                  this.setState({
                    openSelect: !openSelect,
                  });
                }
              }}
            >
              <div
                className={css(styles.mobileOverlayPanel) + ' container-select-custom'}
                style={{
                  position: (isSmallDevice && positionFromTrigger) ? '' : 'absolute',
                  width: (isSmallDevice && positionFromTrigger)
                    ? '100%' : width ? width
                    : this.state.triggerWidth,
                  left: this.state.triggerLeft,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {this.props.showSearch && (
                  <div className={css(styles.searchSticky)}>
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                      <input
                        type="text"
                        placeholder={searchPlaceholder}
                        value={this.state.search}
                        onChange={(e) => this.setSearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                        style={{
                          width: '100%',
                          padding: 'calc(var(--sp-xs) + 2px) calc(var(--sp-md2))',
                          fontSize: 'calc(var(--fs-xs)*1.32075)',
                          border: 'none',
                          borderBottom: '1px solid ' + Colors.borderSelect,
                          outline: 'none',
                          boxSizing: 'border-box',
                          height: 'calc(var(--fs-hero)*1.179245)'
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className={css(styles.mobileOptionsScroll)}>
                  {filteredItems.length > 0 ? options : (
                    this.state.search && (
                      <div
                        style={{
                          padding: 'calc(var(--sp-md2))',
                          fontSize: 'calc(var(--fs-xs)*1.32075)',
                          color: Colors.borderCheckbox,
                          textAlign: 'center',
                        }}
                      >
                        {translate('noSearchFound')}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className={css(styles.optionContainer) + ' container-select-custom'} style={{ width: width || '100%' }}>
              {this.props.showSearch && (
                <div className={css(styles.searchSticky)}>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder={searchPlaceholder}
                      value={this.state.search}
                      onChange={(e) => this.setSearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                      style={{
                        width: '100%',
                        padding: 'calc(var(--sp-xs) + 2px) calc(var(--sp-md2))',
                        fontSize: 'calc(var(--fs-xs)*1.32075)',
                        border: 'none',
                        borderBottom: '1px solid ' + Colors.borderSelect,
                        outline: 'none',
                        boxSizing: 'border-box',
                        height: 'calc(var(--fs-hero)*1.179245)'
                      }}
                    />
                  </div>
                </div>
              )}
              {filteredItems.length > 0 ? options : (
                this.state.search && (
                  <div
                    style={{
                      padding: 'calc(var(--sp-md2))',
                      fontSize: 'calc(var(--fs-xs)*1.32075)',
                      color: Colors.borderCheckbox,
                      textAlign: 'center',
                    }}
                  >
                    {translate('noSearchFound')}
                  </div>
                )
              )}
            </div>
          )
        ) : null}
      </div>
    );
  }
}
